import { NeedTimeslice } from "../data/need";
import { parseDate } from "./dateUtils";

export { needToNeedDefinition } from "./needMath";

export function getNeedForDate(personNeeds: NeedTimeslice[], date: string) {
  return personNeeds.find(
    (need) =>
      parseDate(need.validFrom).getTime() <= parseDate(date).getTime() &&
      (need.validTo == undefined ||
        parseDate(need.validTo).getTime() > parseDate(date).getTime()),
  )!;
}
